import { type KeyboardEvent, type MouseEvent } from 'react'
import { useTheme } from '@dhl-ui/theme'
import { Box, type LogoProps, Logo as MuiLogo } from '@dhl-ui/components'
import { type PageHeaderProps } from '../types'
import { dimensions } from './dimensions'

type Props = Pick<PageHeaderProps, 'onClick' | 'logo'> & Pick<LogoProps, 'fill'>

export const HeaderLogo = ({ onClick, fill, logo }: Props) => {
  const { variant } = useTheme()
  const { width, height } = dimensions[variant]
  const CustomLogo = logo

  // space and enter key while on focus will go to click handler as well
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick?.action?.()
    }
  }

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (onClick?.action) {
      event.preventDefault()
      onClick.action()
    }
  }

  return (
    <Box
      onClick={handleClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      sx={{ width, height, lineHeight: 0, outline: 0 }}
      aria-label={onClick?.label ?? ''}
      aria-hidden={onClick ? undefined : true}
      href={onClick?.href}
      // FIXME: smell a div can not have href
      component={onClick ? 'a' : 'div'}
    >
      {CustomLogo ? (
        <CustomLogo width={width} height={height} fill={fill} />
      ) : (
        <MuiLogo width={width} height={height} fill={fill} />
      )}
    </Box>
  )
}
